import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { first, map } from 'rxjs/operators'

import { Tag } from 'app/models'

import { ApiService } from './api.service'
import { Mapper } from './mapper.service'

@Injectable({
  providedIn: 'root'
})
export class TagService {

  private RESOURCE_ROUTE = 'v3/memberships/tags'

  constructor(private api: ApiService) { }

  public find(id: string): Observable<Tag> {
    return this.api.findAs<Tag>(`${this.RESOURCE_ROUTE}/${id}`, Tag)
  }

  public findAll(params: any): Observable<Tag[]> {
    return this.api.findAllAs<Tag>(this.RESOURCE_ROUTE, params, Tag)
  }

  public create(data: any): Observable<any> {
    return this.api.post(this.RESOURCE_ROUTE, data)
      .pipe(first())
      .pipe(map((r: any) => {
        if (r.result) {
          return Mapper.as<Tag>(r.result, Tag)
        }
    }))
  }

  public delete(id: string): Observable<any> {
    return this.api.delete(`${this.RESOURCE_ROUTE}/${id}`).pipe(first())
  }
}
